
































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { PatientWithWorker } from '@/api/team/types'
import { Worker, User } from '@/types/user'
import { ChangeEvent } from '@/components/call/CallCheckboxInput.vue'

@Component({
  components: {
    CallCheckboxInput: () => import('@/components/call/CallCheckboxInput.vue'),
    CheckboxInput: () => import('@/components/common/StyledCheckboxInput.vue')
  }
})
export default class CallTeamPatient extends Vue {
  $store!: ExStore
  allWorker = false

  @Prop() patient!: PatientWithWorker

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get name() {
    return this.getUserName(this.patient)
  }

  get id() {
    return `adc-check${this.patient.id}`
  }

  get workersWithoutSelf() {
    return this.patient.workers.filter(worker => worker.id !== this.userInfo.id)
  }

  getWorkerOccupation(worker: Worker) {
    return worker.occupation.name
  }
  getWorkerName(worker: Worker) {
    return this.getUserName(worker)
  }
  getUserName(user: User) {
    return `${user.lastName}${user.firstName} (${user.lastNameReading}${user.firstNameReading})`
  }

  onWorkerCheck(e: ChangeEvent) {
    if (!e.checked && e.active) {
      this.allWorker = false
    }
  }

  onAllWorkerCheck(checked: boolean) {
    this.allWorker = checked
    const action = checked ? 'call/addCallPartners' : 'call/removeCallPartners'
    this.$store.dispatch(action, this.workersWithoutSelf)
  }
}
